import CampaignStatus from '@/Enums/CampaignManagement/CampaignStatus.enum';
import CampaignsTableColumns from '@/Enums/CampaignManagement/CampaignsTableColumns.enum';
import { Channel } from '@/Enums/Channel.enum';
import { ILineItemGeo } from '@/Interfaces/CampaignManagement/LineItem.interface';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import type { LineItemChannel } from '@/types/LineItem/channel.types';
import { GridSortModel } from '@mui/x-data-grid-pro';

// request abort
export const CAMPAIGN_MANAGEMENT_REQUEST = {
  CAMPAIGNS_DATA: 'CAMPAIGNS_DATA',
};

export const NEW_ITEM_ID = 'new';

export const FILTERS_BASE_TAB_ID = 'campaign-management-filter-tab';

export const ChannelLabels: Record<LineItemChannel, string> = {
  [Channel.CTV]: 'Streaming TV',
  [Channel.OLV]: 'OLV',
  [Channel.Display]: 'Display',
  [Channel.Audio]: 'Audio',
};

export const LineItemChannels: LineItemChannel[] = [Channel.CTV, Channel.OLV, Channel.Display, Channel.Audio];

export const FILTERS_CHANNELS_OPTIONS: IControlOption<string, LineItemChannel>[] = LineItemChannels.map(channel => ({
  label: ChannelLabels[channel],
  value: channel,
}));

export const CAMPAIGN_MANAGEMENT_ROW_TYPE = {
  CAMPAIGN: 'campaign',
  LINE_ITEM: 'lineItem',
  FLIGHT: 'flight',
};

export const STATUS_LABELS = {
  [CampaignStatus.INACTIVE]: 'Inactive',
  [CampaignStatus.ACTIVE]: 'Active',
  [CampaignStatus.DRAFT]: 'Draft',
  [CampaignStatus.APPROVAL_REQUIRED]: 'Approval Required',
};

export const STATUS_OPTIONS: IControlOption<string, CampaignStatus>[] = Object.values(CampaignStatus).map(status => ({
  label: STATUS_LABELS[status],
  value: status,
}));

export const DEFAULT_ASSOCIATION_WEIGHT_REL = 1;

export const LEVEL_VALUES = {
  CAMPAIGN: 'Campaign',
  FULL_VIEW: 'Full View',
};

export const LEVEL_LABELS = {
  [LEVEL_VALUES.CAMPAIGN]: 'Campaign',
  [LEVEL_VALUES.FULL_VIEW]: 'Full View',
};

export const LEVEL_OPTIONS = [
  { label: LEVEL_LABELS[LEVEL_VALUES.CAMPAIGN], value: LEVEL_VALUES.CAMPAIGN },
  { label: LEVEL_LABELS[LEVEL_VALUES.FULL_VIEW], value: LEVEL_VALUES.FULL_VIEW },
];

export const LINE_ITEM_DEFAULT_GEO: ILineItemGeo = {
  included: [],
  excluded: [],
};

export const DEFAULT_SORT_MODEL: GridSortModel = [{ field: CampaignsTableColumns.LAST_UPDATED, sort: 'desc' }];
